import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=714d5662"
import script from "./DialogMessage.vue?vue&type=script&lang=js"
export * from "./DialogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports